/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* eslint-disable react/prop-types */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MapsView.scss';
import BasePanel from '../../Panels';
import AddComposition from '../../Panels/AddComposition';
import EditRemoveComposition from '../../Panels/EditRemoveComposition';

class MapsView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      composition: null,
    };
    this.editComposition = this.editComposition.bind(this);
    this.cancelEditComposition = this.cancelEditComposition.bind(this);
  }

  editComposition = (composition) => this.setState({ isEditing: true, composition: composition })
  cancelEditComposition = () => this.setState({ isEditing: false })

  render() {
    return (
      <div>
        <div className="col-sm-6">
         {!this.state.isEditing ? 
            <BasePanel
              fullWidth
              user={this.props.user}
              userHasFeatureCode="0009"
              panelType="warning"
              panelTitle="Dodaj kompozycję."
            >
              <AddComposition cancelEditComposition={this.cancelEditComposition} />
            </BasePanel>
          : null }
          {this.state.isEditing ?  
            <BasePanel
              fullWidth
              user={this.props.user}
              userHasFeatureCode="0009"
              panelType="info"
              panelTitle="Edycja kompozycji."
            >
              <AddComposition composition={this.state.composition} cancelEditComposition={this.cancelEditComposition} />
            </BasePanel>
          : null}
        </div>
        <div className="col-sm-6">
          <BasePanel
            fullWidth
            user={this.props.user}
            userHasFeatureCode="0009"
            panelType="warning"
            panelTitle="Edytuj/usuń kompozycję."
          >
            <EditRemoveComposition editComposition={this.editComposition}/>
          </BasePanel>
        </div>
      </div>
    );
  }
}

MapsView.PropTypes = {
  viewName: PropTypes.string.isRequired,
  viewDesc: PropTypes.string.isRequired,
};

export default withStyles(s)(MapsView);


// WEBPACK FOOTER //
// src/components/Modals/Settings/SettingsViews/MapsView/MapsView.js